import {
  action,
  observable,
  makeObservable,
  runInAction,
} from "mobx";
import api from "../../../api";
import { RadioChangeEvent, message } from "antd";
import CommonStore from "../common_store";

class UserPermissionStore {
  commonStore: CommonStore;
  constructor(baseStore: CommonStore) {
    this.commonStore = baseStore;
    makeObservable(this);
  }
  @observable subjectNo: string = "";
  //搜索表单字段
  @observable searchForm: powerSearchData = { subject:"group"};
  @observable tableData: any = {};
  //表格加载状态
  @observable tableLoad: boolean = true;
  @observable tableLoadModal: boolean = true;
  //分页信息
  @observable pageData: IPageData = {
    page: 1,
    size: 10,
    changePage: (page: number, size: number) => {
      runInAction(() => {
        this.pageData.page = page;
        this.pageData.size = size;
        this.pageData = { ...this.pageData };
      });
      this.getUserPermissionPage();
    },
  };
  @observable data: any = {};
  @observable allVisitedPermissions: any = {};
  @observable managementResource: string = "";
  @observable visitedPermissions: any = this.data
    ? JSON.parse(JSON.stringify(this.data))
    : {};

  @observable permissionsText: any = {
    readable: "查看",
    writable: "编辑",
    grantable: "授权",
    manageable: "管理",
  };

  @observable getOperable: any = {
    readable: "readOperable",
    writable: "writeOperable",
    grantable: "grantOperable",
    manageable: "manageOperable",
  };

  @observable getAll: any = {
    readable: "readAll",
    writable: "writeAll",
    grantable: "grantAll",
    manageable: "manageAll",
  };

  @observable getAble: any = {
    readAll: "readable",
    writeAll: "writable",
    grantAll: "grantable",
    manageAll: "manageable",
  };

  @observable indeterminate: any = {
    readable: false,
    writable: false,
    grantable: false,
    manageable: false,
  };

  @observable checkboxAll: any = {
    readable: false,
    writable: false,
    grantable: false,
    manageable: false,
  };

  @observable manageablePermission: boolean = false;//功能权限按钮管理权限

  @action topCheckbox(e: any, checkboxValue: string) {
    this.data[checkboxValue] = e.target.checked;
    if (this.data.hasChildResource && this.data[this.getAll[checkboxValue]+'Operable']) {
    this.data[this.getAll[checkboxValue]] = e.target.checked;}
    if (e.target.checked) {
      if (checkboxValue === "writable" || checkboxValue === "grantable") {
        this.data["readable"] = e.target.checked;
        if (this.data.hasChildResource && this.data.readAllOperable) {
          this.data['readAll'] = e.target.checked;
        }
      } else if (checkboxValue === "manageable") {
        this.data["readable"] = e.target.checked;
        this.data["writable"] = e.target.checked;
        this.data["grantable"] = e.target.checked;
        if (this.data.hasChildResource && this.data.readAllOperable && this.data.writeAllOperable && this.data.grantAllOperable) {
          this.data['readAll'] = e.target.checked;
          this.data['writeAll'] = e.target.checked;
          this.data['grantAll'] = e.target.checked;
        }
      }
    } else {
      if (checkboxValue === "readable") {
        this.data["manageable"] = e.target.checked;
        this.data["writable"] = e.target.checked;
        this.data["grantable"] = e.target.checked;
        this.data[this.getAll["manageable"]] = e.target.checked;
        this.data[this.getAll["writable"]] = e.target.checked;
        this.data[this.getAll["grantable"]] = e.target.checked;
        this.data[this.getAll[checkboxValue]] = e.target.checked;
        this.data.resourceList.forEach((item: any) => {
          item[checkboxValue] = e.target.checked;
          item["manageable"] = e.target.checked;
          item["grantable"] = e.target.checked;
          item["writable"] = e.target.checked;
        });
      } else if (checkboxValue === "writable" || checkboxValue === "grantable") {
        this.data["manageable"] = e.target.checked;
        this.data[this.getAll[checkboxValue]] = e.target.checked;
        this.data[this.getAll["manageable"]] = e.target.checked;
        this.data.resourceList.forEach((item: any) => {
          item[checkboxValue] = e.target.checked;
          item["manageable"] = e.target.checked;
        });
      }
      //  else if (checkboxValue === "grantable") {
      //   this.data["manageable"] = e.target.checked;
      //   this.data[this.getAll[checkboxValue]] = e.target.checked;
      //   this.data[this.getAll["manageable"]] = e.target.checked;
      //   this.data.resourceList.forEach((item: any) => {
      //     item[checkboxValue] = e.target.checked;
      //     item["manageable"] = e.target.checked;
      //   });
      // } 
      else {
        this.data[this.getAll[checkboxValue]] = e.target.checked;
        this.data.resourceList.forEach((item: any) => {
          item[checkboxValue] = e.target.checked;
        });
      }
    }
    this.setIndeterminate();
    runInAction(() => {
      this.visitedPermissions = { ...this.data };
    });
  }

  @action changeCheckAll(e: any, checkboxValue: string) {
    if (!e.target.checked) {
      if (checkboxValue === "readable") {
        this.data.resourceList.forEach((item: any) => {
          item["writable"] = e.target.checked;
          item["grantable"] = e.target.checked;
          item["manageable"] = e.target.checked;
        });
      } else if (checkboxValue === "writable" || checkboxValue === "grantable") {
        this.data.resourceList.forEach((item: any) => {
          item["manageable"] = e.target.checked;
        });
      } 
      // else if (checkboxValue === "grantable") {
      //   this.data.resourceList.forEach((item: any) => {
      //     item["manageable"] = e.target.checked;
      //   });
      // }
    } else {
      if (checkboxValue === "writable" || checkboxValue === "grantable") {
        this.data.resourceList.forEach((item: any) => {
          item["readable"] = item[this.getOperable["readable"]]?e.target.checked:item["readable"];
        });
      } else if (checkboxValue === "manageable") {
        this.data.resourceList.forEach((item: any) => {
          item["readable"] = item[this.getOperable["readable"]]?e.target.checked:item["readable"];
          item["writable"] = item[this.getOperable["writable"]]?e.target.checked:item["writable"];
          item["grantable"] = item[this.getOperable["grantable"]]?e.target.checked:item["grantable"];
        });
      }
    }
    this.data.resourceList.forEach((item: any) => {
      item[checkboxValue] = item[this.getOperable[checkboxValue]]?e.target.checked:item[checkboxValue];
    });
    this.setIndeterminate();
    this.indeterminate = { ...this.indeterminate };
    this.data.resourceList = [...this.data.resourceList];
    runInAction(() => {
      this.visitedPermissions = { ...this.data };
    });
  }

  @action changeCheckbox = (e: any, record: any, checkboxValue: string) => {
    record[checkboxValue] = e.target.checked;
    if (e.target.checked) {
      if (checkboxValue === "writable" || checkboxValue === "grantable") {
        record["readable"] = e.target.checked;
      } else if (checkboxValue === "manageable") {
        record["readable"] = e.target.checked;
        record["writable"] = e.target.checked;
        record["grantable"] = e.target.checked;
      }
    } else {
      if (checkboxValue === "readable") {
        record["writable"] = e.target.checked;
        record["grantable"] = e.target.checked;
        record["manageable"] = e.target.checked;
      } else if (checkboxValue === "writable" || checkboxValue === "grantable") {
        record["manageable"] = e.target.checked;
      } 
      // else if (checkboxValue === "grantable") {
      //   record["manageable"] = e.target.checked;
      // }
    }

    this.setIndeterminate();
    this.indeterminate = { ...this.indeterminate };
    this.data.resourceList = [...this.data.resourceList];
    runInAction(() => {
      this.visitedPermissions = { ...this.data };
    });
  };
  @action setIndeterminate() {
    Object.keys(this.indeterminate).forEach((item1: any) => {
      this.indeterminate[item1] =
        this.data.resourceList.filter((item: any) => item[item1]).length > 0 &&
        this.data.resourceList.filter((item: any) => item[item1]).length !==
          this.data.resourceList.length;
      this.checkboxAll[item1] =
        this.data.resourceList.filter((item: any) => item[item1]).length > 0 &&
        this.data.resourceList.filter((item: any) => item[item1]).length ===
          this.data.resourceList.length;
    });
  }

  @action onChangeRadio = (e: RadioChangeEvent, radioValue: string) => {
    this.data[radioValue] = e.target.value;
    if (e.target.value) {
      if (radioValue === "writeAll" || radioValue === "grantAll") {
        this.data["readAll"] = e.target.value;
        this.data["readable"] = e.target.value;
      } 
      // else if (radioValue === "grantAll") {
      //   this.data["readAll"] = e.target.value;
      //   this.data["readable"] = e.target.value;
      // } 
      else if (radioValue === "manageAll") {
        this.data["readAll"] = e.target.value;
        this.data["writeAll"] = e.target.value;
        this.data["grantAll"] = e.target.value;
        this.data["readable"] = e.target.value;
        this.data["writable"] = e.target.value;
        this.data["grantable"] = e.target.value;
      }
    } else {
      if (radioValue === "readAll") {
        this.data["manageAll"] = e.target.value;
        this.data["writeAll"] = e.target.value;
        this.data["grantAll"] = e.target.value;
        this.data.resourceList.forEach((item1: any) => {
          item1[this.getOperable[this.getAble[radioValue]]] = !this.data[radioValue];
          item1["grantOperable"] = !this.data[radioValue];
          item1["writeOperable"] = !this.data[radioValue];
          item1["manageOperable"] = !this.data[radioValue];
        });
      } else if (radioValue === "writeAll" || radioValue === "grantAll") {
        this.data["manageAll"] = e.target.value;
        this.data.resourceList.forEach((item1: any) => {
          item1[this.getOperable[this.getAble[radioValue]]] = !this.data[radioValue];
          item1["manageOperable"] = !this.data[radioValue];
        });
      } 
      // else if (radioValue === "grantAll") {
      //   this.data["manageAll"] = e.target.value;
      //   this.data.resourceList.forEach((item1: any) => {
      //     item1[this.getOperable[this.getAble[radioValue]]] = !this.data[radioValue];
      //     item1["manageOperable"] = !this.data[radioValue];
      //   });
      // }
       else {
        this.data.resourceList.forEach((item1: any) => {
          item1[this.getOperable[this.getAble[radioValue]]] = !this.data[radioValue];
        });
      }
    }
    runInAction(() => {
      this.visitedPermissions = { ...this.data };
    });
  };

  @action
  getPermissionPData(record?: any, data?: any) {
    this.subjectNo = record ? record.no : this.subjectNo;
    this.manageablePermission = record ? record.manageable : this.manageablePermission 
    if (data) {
      this.commonStore.findKey(
        data,
        data[0].children ? data[0].children[0].key : data[0].key
      );
      this.commonStore.permissionBreadcrumbData();
    }
    api.userPermissionApi
      .getSubjectResource({
        subject: this.searchForm.subject,
        managementResource: this.commonStore.managementResource,
        subjectNo: this.subjectNo,
      })
      .then((res: any) => {
        if (this.allVisitedPermissions[this.commonStore.managementResource]) {
          //不是首次进入
          this.data = {
            ...this.allVisitedPermissions[this.commonStore.managementResource],
          };
          this.visitedPermissions = { ...this.data };
        } else {
          //第一次进入
          runInAction(() => {
            this.data = res.data;
            this.visitedPermissions = { ...this.data };
          });
        }
        this.setIndeterminate();
      })
      .catch((e: any) => {});
  }

  @action
  setPermissionPData() {
    Object.keys(this.getAble).forEach((item: any) => {
      if (this.data[item]) {
        this.data.resourceList.forEach((item1: any) => {
          item1[this.getAble[item]] = true;
          item1[this.getOperable[this.getAble[item]]] = false;
        });
      }
    });
    this.allVisitedPermissions[this.commonStore.managementResource] = {
      ...this.data,
    };
    const data = {
      subject: this.searchForm.subject,
      relationList: JSON.parse(
        JSON.stringify(Object.values(this.allVisitedPermissions))
      ),
      subjectNo: this.subjectNo,
    };

    api.userPermissionApi
      .setSubjectResource(data)
      .then((res: any) => {
        runInAction(() => {
          this.allVisitedPermissions = {};
        });
        message.success("保存成功");
      })
      .catch((e: any) => {
        runInAction(() => {
          this.allVisitedPermissions = {};
        });
      });
  }

  setSearchForm(obj: powerSearchData) {
    runInAction(() => {
      this.searchForm = obj;
    });
  }

  //重置分页
  resetPage() {
    runInAction(() => {
      this.pageData.page = 1;
    });
  }

  @action
  getUserPermissionPage() {
    runInAction(() => {
      this.tableData = {};
      this.tableLoad = true;
    });
    const data = { ...this.searchForm };
    data.size = this.pageData.size;
    data.page = this.pageData.page;
    api.userPermissionApi
      .getUserPermissionPage(data)
      .then((res: any) => {
        if (res.code == 200) {
          runInAction(() => {
            this.tableData = res.data;
            this.tableData = { ...this.tableData };
            this.tableLoad = false;
          });
          this.commonStore.getPagePermission("user_permission");
        }
      })
      .catch((e: any) => {
        runInAction(() => {
          this.tableLoad = false;
        });
      });
  }

}

export default UserPermissionStore;
